import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface ReleasableAssignment {
  assignmentId: string;
  releaseDate?: string;
}

interface CreateConfig extends AxiosRequestConfig {
  body: ReleasableAssignment;
  data: ReleasableAssignment;
  method: 'PUT';
  url: `/classes/${string}/assignments`;
}

/**
 * Add an assignment to a class or re-enable a previously (soft) removed assignment.
 * Currently, also used to set the default assignment at release time.
 *
 * PUT /vo/v1/classes/{classId}/assignments
 *
 * { assignmentId: string, releaseDate?: string }
 */
export const create = (
  classId: string,
  data: ReleasableAssignment,
): CreateConfig => {
  return {
    baseURL: BASE_API,
    method: 'PUT',
    url: `/classes/${classId}/assignments`,
    body: data,
    data,
  } as const;
};
